<template>
  <div class="flex flex-column gap-3" :style="{ paddingTop: '10px' }">
    <div class="flex flex-column gap-2" v-if="hasSuspension">
      <a-descriptions :column="1" size="small" class="col-fixed p-0">
        <a-descriptions-item label="Author">
          {{ suspensionAuthorName }}
        </a-descriptions-item>
        <a-descriptions-item label="Reason">
          {{ associate.suspension.reason }}
        </a-descriptions-item>
        <a-descriptions-item label="Start Date">
          {{ associate.suspension?.start_date ? formatDateString(associate.suspension?.start_date) : ' - ' }}
        </a-descriptions-item>
      </a-descriptions>

      <div class="col-12 flex gap-2">
        <a-button
          v-if="
            hasUncontrolledPermission('manage_associates', {
              id: associate.id
            })
          "
          icon="redo"
          :loading="loadingRelease"
          @click="releaseFromSuspension"
          >Unblock</a-button
        >
      </div>
    </div>
    <div
      class="grid"
      v-else-if="
        hasUncontrolledPermission('manage_associates', {
          id: associate.id
        })
      "
    >
      <div class="col-12 flex gap-2" v-if="!creatingSuspension">
        <a-button icon="plus" @click="switchAddSuspension">Block</a-button>
      </div>
      <div class="grid m-0" v-else>
        <b class="col-4">Reason <span class="required-field">*</span></b>
        <div class="col-8">
          <a-textarea v-model="newSuspension.reason" :autoSize="true" placeholder="Enter blocked reason" />
        </div>

        <b class="col-4">Start Date </b>
        <div class="col-8">
          <a-date-picker
            v-model="newSuspension.start_date"
            placeholder="Enter start date"
            class="w-full"
            :format="visualDateFormat"
          />
        </div>

        <div class="col-12 flex gap-2 justify-content-end">
          <a-button @click="cancelSuspension">Cancel</a-button>
          <a-button type="danger" @click="setSuspension" :disabled="saveSuspensionDisabled">Block </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import permissionMixin from '@/mixins/permissionMixin'
import Util from '@/util'
import { Button, DatePicker, Descriptions, Input, Modal, notification } from 'ant-design-vue'
import moment from 'moment-timezone'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: profileActions, mapState: profileState } = createNamespacedHelpers('profile')

export default {
  components: {
    'a-button': Button,
    'a-date-picker': DatePicker,
    'a-textarea': Input.TextArea,
    'a-descriptions': Descriptions,
    'a-descriptions-item': Descriptions.Item
  },
  mixins: [permissionMixin],
  data() {
    return {
      creatingSuspension: false,
      newSuspension: {
        reason: undefined,
        start_date: undefined
      },

      loadingRelease: false
    }
  },
  computed: {
    ...profileState({
      associate: state => state.associate
    }),
    hasSuspension() {
      return this.associate.suspension !== null
    },
    visualDateFormat() {
      return this.$store.state.applicationState.dateFormat
    },
    suspensionAuthorName() {
      if (!this.hasSuspension) {
        return '-'
      }

      const { first_name, last_name } = this.associate.suspension.author || {}
      return Util.combineAssociateName(first_name, last_name)
    },
    isSuspensionDurationIndefinite() {
      return Boolean(this.associate.suspension.indefinite_period)
    },
    saveSuspensionDisabled() {
      const { reason } = this.newSuspension

      const isReasonValid = reason && reason.length > 0

      return !isReasonValid
    }
  },
  methods: {
    ...profileActions(['postAssociateSuspension', 'postAssociateReleaseSuspension']),

    openCreate() {
      if (!this.hasSuspension) {
        this.creatingSuspension = true
      }
    },

    showNotification(type, message, description) {
      notification[type]({
        message: message,
        description: description
      })
    },

    formatDateString(dateString) {
      return moment(dateString).utc().format('MM/DD/YYYY')
    },

    async releaseFromSuspension() {
      this.loadingRelease = true
      try {
        await this.postAssociateReleaseSuspension({
          associate_number: this.associate.associate_number
        })

        this.showNotification('success', 'Unblock', `Associate ${this.associate.associate_number} is now unblock`)
      } catch (error) {
        this.showNotification('error', 'Suspension Release Error', typeof error === 'string' ? error : error.message)
      } finally {
        this.loadingRelease = false
      }
    },

    switchAddSuspension() {
      this.creatingSuspension = !this.creatingSuspension
    },

    setSuspension() {
      Modal.confirm({
        title: 'Are you sure?',
        content: `You are trying to block an associate "${this.associate.associate_number}".`,
        onOk: async () => {
          try {
            await this.postAssociateSuspension({
              associate_number: this.associate.associate_number,
              suspension: this.newSuspension
            })

            this.showNotification('success', 'Block', `Associate ${this.associate.associate_number} is now blocked`)

            this.resetNewSuspension()
            this.switchAddSuspension()
          } catch (error) {
            this.showNotification('error', 'Error', typeof error === 'string' ? error : error.message)
          }
        },
        onCancel() {}
      })
    },
    resetNewSuspension() {
      this.newSuspension.reason = undefined
    },
    cancelSuspension() {
      this.resetNewSuspension()
      this.switchAddSuspension()
    }
  }
}
</script>

<style scoped>
span {
  text-align: left !important;
}

.ant-calendar-picker {
  margin: 0;
  min-width: unset !important;
}
</style>
